import cx from "classnames"
import React from "react"
import { RatingIcons, RatingIconsPropsType } from "./RatingIcons"

type RatingInputPropsType = Omit<RatingIconsPropsType, "editable">

export const RatingInput = ({ disabled, ...props }: RatingInputPropsType) => {
  return (
    <div
      className={cx("cobalt-rating-input", {
        "cobalt-rating-input--disabled": disabled,
      })}
    >
      <RatingIcons {...props} editable={!disabled} />
    </div>
  )
}
